/* Instrument version = semantic version + short hash of the item bank and scoring constants.
   The hash is generated by `npm run version:gen` and verified by `npm run version:check` (run by
   `npm run build` and CI). Any change to item wording, keying or scoring changes the hash, which
   forces a semver bump. Stored and submitted responses always record INSTRUMENT_VERSION. */

/** Bump this whenever wording, keying or scoring changes (minor for wording/threshold tweaks, major for new items). */
export const INSTRUMENT_SEMVER = '2.0.0';
export const INSTRUMENT_HASH = '4c1a99af';
export const INSTRUMENT_VERSION = `${INSTRUMENT_SEMVER}+${INSTRUMENT_HASH}`;

/** Every released version, newest first. The submissions API accepts only these. */
export const VERSION_HISTORY: readonly { semver: string; hash: string }[] = [
  { semver: '2.0.0', hash: '4c1a99af' },
];
export const KNOWN_VERSIONS: readonly string[] = VERSION_HISTORY.map((v) => `${v.semver}+${v.hash}`);
